/** Objeto constante (evita problemas de binding ESM com `export enum` em alguns browsers). */
export const CenterScreensEnum = {
  Operational: 1,
  Tactical: 2,
  Strategic: 3,
} as const;

export type CenterScreenValue =
  (typeof CenterScreensEnum)[keyof typeof CenterScreensEnum];
